import { ApprovalLimit } from "./approvallimit";
import { ApprovalHierarchy } from "./approvalhierarchy";
import { Organization } from "./organization";
import { Role } from "./role";
import { SubGroup } from "./subgroup";
import { UserFinancialCommunityAssoc } from './userfinancialcommunityassoc';

export class User {
    azureGUID: string;
    edhUserId: number;
    displayName: string;
    firstName: string;
    lastName: string;
    userName: string;
    jobTitle: string;
    emailAddress: string;
    contactID: number;
    adEmployeeId: string;
    userOrgs: Organization[];
    role: Role;
    subGroup: SubGroup;
    marketApprovalLimit: ApprovalLimit;
    approvalLimits: ApprovalLimit[];
    marketApprovalHierarchy: ApprovalHierarchy;
    approvalHierarchies: ApprovalHierarchy[];
    userFinancialCommunityAssocs: UserFinancialCommunityAssoc[]

    //"ID" from EDH shr.Contact
    id: number;
}
